import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'
import {AccessRights} from 'constants'

export default class InvoiceDescriptionStrategy extends DescriptionStrategy {
    constructor({
        reportUrl = '',
        name = '',
    }) {
        super()

        this.params = {
            reportUrl,
            name,
        }

        this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
        }

        this.userType = null

        this.onStatePropertyChanged('userRights', (userRights) => {
            if (userRights[AccessRights.GENERATE_MONEY_REPORTS])
                this.userType = UserTypes.MANAGE_BILLING_REPORT
            else
                this.userType = UserTypes.REGULAR

        })
    }

    getHeader() {
        return messageResource.getMessage(this.params.name) + ' ' + messageResource.getMessage('report.common.report')
    }

    getDescription() {
        let firstParagraph
        let secondParagraph
        let thirdParagraph
        switch (this.userType) {
            case UserTypes.MANAGE_BILLING_REPORT:
                firstParagraph = messageResource.getEscapedMessage('dashboard.description.invoice.user_with_right.part1')
                secondParagraph = messageResource.getEscapedMessage('dashboard.description.invoice.user_with_right.part2')
                thirdParagraph = ''
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.REGULAR:
                return ''
        }
    }

    _createDescription(first, second, third) {
        return '<div>' +
               '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '  <div class="thirdParagraph">' + third + '</div>' +
               '</div>'
    }

    getDetailsCallback() {
        openUserGuidePage('reporting#report-pdf-invoices')
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }
}

const UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport',
}



// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/InvoiceDescriptionStrategy.js